<div class="date-picker">
  <div class="header">
    <common-ui-components-temp-ngx-button
      (clickHandler)="confirmDateSelection()"
      size="tiny"
      class="confirm-selection"
    >
      تایید
    </common-ui-components-temp-ngx-button>
    <span (click)="hideDatePicker()">انصراف</span>
  </div>
  <div class="selects">
    <ui-form-field
      type="wheel-select"
      label="ماه"
      [(ngModel)]="month"
      [options]="monthOptions"
    ></ui-form-field>

    <ui-form-field
      type="wheel-select"
      label="سال"
      [(ngModel)]="year"
      [options]="yearOptions"
    ></ui-form-field>
  </div>
</div>
